import { render, staticRenderFns } from "./TabAboutUs.vue?vue&type=template&id=730da328&"
import script from "./TabAboutUs.vue?vue&type=script&lang=js&"
export * from "./TabAboutUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports